var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#BDE0D5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 15,
    fill: "white",
    stroke: "#699D8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2831 21.1993C30.6736 20.8088 30.6736 20.1756 30.2831 19.7851C29.8926 19.3945 29.2594 19.3945 28.8689 19.7851L22.493 26.161L20.1524 23.8204C19.7619 23.4299 19.1287 23.4299 18.7382 23.8204C18.3477 24.2109 18.3477 24.8441 18.7382 25.2346L21.7944 28.2908C22.185 28.6813 22.8181 28.6813 23.2086 28.2908C23.2461 28.2533 23.28 28.2136 23.3103 28.1721L30.2831 21.1993Z",
    fill: "#699D8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.f40970c6.svg";
export { ForwardRef as ReactComponent };